import React from 'react';
import { Link } from 'next-view-transitions';
import Image from 'next/image'

import type { MetaInfo } from '@/libs/markdown'
import styles from './list.module.css'

export interface ListRecordRaw extends MetaInfo {
  id: `${number}`;
}
export default function List({ dataSource }: { dataSource: ListRecordRaw[] }) {
  return (
    <>
      {
        dataSource.map((item) => <Link href={`/blog/${item.id}`} key={item.id}>
          <div className={styles.wrapper} style={{ '--bg': `url(${item.cover ?? '/images/1.jpg'})` } as React.CSSProperties}>
            <Image src={item.cover ?? '/images/1.jpg'} width={176} height={98} alt="cover" className={styles.cover} />
            <div className={styles.info}>
              <div className={styles['blog-info']}>
                <p className={styles.title}>{item.title}</p>
                <p className={styles.desc}>{item.description}</p>
              </div>
              <div className={styles['blog-date']}>
                {item.date}
                {/* <div>{item?.tags.toString() ?? ''}</div> */}
              </div>
            </div>
          </div>
        </Link>)
      }
    </>
  )
}
